import React from "react";
import { Modal } from "semantic-ui-react";
import { Widget } from "@typeform/embed-react";

export default function SurveyModal({
  survey,
  openModal,
  closeModal,
  currentUser,
}) {
  return (
    <Modal open={openModal} onClose={closeModal} closeIcon>
      <Modal.Content>
        <Widget
          id={survey.code}
          style={{ width: '100%', height: '500px' }}
          hidden={{
            user_id: currentUser.id,
            survey_id: survey.id,
            name: currentUser.name,
            email: currentUser.email,
          }}
        />
      </Modal.Content>
    </Modal>
  );
}
